import cn from 'classnames';

interface ShefNameProps {
  name: string;
  className?: string;
  nameSize?: 'text-xl' | 'text-2xl' | 'text-h4' | 'text-lg';
  truncate?: boolean;
}

export const ShefHandwrittenName: React.FC<ShefNameProps> = ({
  name,
  className,
  nameSize = 'text-2xl',
  truncate = false,
}) => {
  const handwrittenName = (
    <span
      className={cn('w-full pl-1 font-quick-writers text-raspberry', {
        'text-2xl': nameSize === 'text-2xl',
        'text-xl': nameSize === 'text-xl',
        'text-h4': nameSize === 'text-h4',
        'text-lg': nameSize === 'text-lg',
        truncate,
      })}>
      {name}
    </span>
  );

  const shefAndName = (
    <div className={cn(className, 'flex items-baseline whitespace-nowrap', { 'w-full': truncate })}>
      <p>Shef</p>
      {handwrittenName}
    </div>
  );

  return shefAndName;
};
